import { Environment, PRODUCT_READING, PRODUCT_LECTURA } from 'lib/constants';

import GameCategories from './GameCategories';
import BookIds from './BookIds';

const bookListDefaults = {
  release: {
    [PRODUCT_READING]: [
      Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.PROD, Environment.STAGING, Environment.LOCALDEV,
    ],
    [PRODUCT_LECTURA]: [],
  },
};

const spanishBookListDefaults = {
  release: {
    [PRODUCT_READING]: [],
    [PRODUCT_LECTURA]: [
      Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.PROD, Environment.STAGING, Environment.LOCALDEV,
    ],
  },
};

const BookList = [
  {
    canonicalName: BookIds.BACH_TAKES_A_WALK,
    displayName: 'Bach Takes a Walk',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.BECAME_AMERICANS,
    displayName: 'The Day They Became Americans',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    summary: 'Three students who were born in different countries come together on a special day when they become American citizens.',
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.BEST_PRESENT,
    displayName: 'The Best Present',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    summary: 'Anjali and Anuj try to find Mom the best birthday present while they\'re at a baseball game. What will they choose?',
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.BIG_RIDE,
    displayName: 'The Big Ride',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.BUSY_WOLF,
    displayName: 'The Busy Wolf',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.CAN_I_GET_A_SIP,
    displayName: 'Can I Get a Sip?',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.CHANGING_SOCIAL_STRUCTURES,
    displayName: 'Changing Social Structures in the Middle Ages',
    release: { [PRODUCT_READING]: [Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.LOCALDEV] },
    categories: [GameCategories.BOOKS],
    chapterNames: ['Chapter1', 'Chapter2', 'Chapter3', 'Chapter4'],
    chapterSummaries: [
      'The fall of the Roman Empire led to an unstable political situation in Europe. This allowed feudalism to rise, a system where kings and nobles gained wealth from land that peasants worked. ',
      'Trade became more complicated after the fall of the Roman Empire due to the crumbling of roads, as well as political instability. Still, new trade routes formed that allowed new ideas and goods to be shared. ',
      'Trade routes also spread disease, such as the Black Plague. Historians believe about one third of people living in Europe at the time of the Black Plague died as a result of the illness.',
      'Peasants grew tired of the terrible working conditions that they dealt with under the nobles and eventually, the peasants revolted. The revolt gradually led to fairer wages and more work opportunities.',
    ],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.CHERRY_TREE,
    displayName: 'The Cherry Tree',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.CREATED_EQUAL,
    displayName: 'Created Equal',
    release: { [PRODUCT_READING]: [Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.LOCALDEV] },
    categories: [GameCategories.BOOKS],
    chapterNames: ['Chapter1', 'Chapter2', 'Chapter3', 'Chapter4'],
    chapterSummaries: [
      'Christopher lives and works in a family bakery in Boston. He misses his father and does not like the British soldiers. Christopher talks to him and they decide to invent a new bread recipe together.',
      'James, a British soldier misses England and his son. James wishes that the colonists would just listen to the king so the war could end and no one would have to be away from their families.',
      'Betsy, an enslaved African American woman, is fixing a dress at the tailor shop. Her owner thinks the colonists should be loyal to the king. She dreams of slavery ending and opening her own shop.',
      'Alexander Hamilton proposes an idea for a new form of government. James Madison and John Jay help him write essays to convince the public to support the Constitution. Finally, the Constitution is ratified.',
    ],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.DANCING_BEE,
    displayName: 'The Dancing Bee',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.DARK_SIDE_OF_MOON,
    displayName: 'The Dark Side of the Moon',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.DOG_HAS_A_NOSE,
    displayName: 'A Dog Has a Nose',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.EASY_PEAS,
    displayName: 'Easy Peas',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.EGG_HATCHES,
    displayName: 'An Egg Hatches',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.FIVE_SENSES,
    displayName: 'The Five Senses and Beyond',
    release: { [PRODUCT_READING]: [Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.LOCALDEV] },
    categories: [GameCategories.BOOKS],
    chapterNames: ['Chapter1', 'Chapter2', 'Chapter3', 'Chapter4'],
    chapterSummaries: [
      'Humans have five main senses: sight, hearing, touch, taste, and smell. These senses help keep us safe and to communicate with others.',
      'Taste and smell play a major role in our enjoyment of food. There are four flavors we taste: sweet, salty, sour, and bitter.',
      'Sight and sound are complex senses that help us understand the world. Our pupils get bigger or smaller to let in the right amount of light for us to see. Our ears are shaped like shells to help us capture sounds.',
      'Some people have conditions where the senses don\'t work properly. When one sense does not work, other senses usually improve. Also, many animals have senses that humans do not have.',
    ],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.FOUR_NATIVE_AMERICAN_WOMEN,
    displayName: 'Four Native American Women Who Shine Through History',
    release: { [PRODUCT_READING]: [Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.LOCALDEV] },
    categories: [GameCategories.BOOKS],
    chapterNames: ['Chapter1', 'Chapter2', 'Chapter3', 'Chapter4'],
    chapterSummaries: [
      'Nanye-hi was a Cherokee woman who helped her husband in a battle to defeat the Creeks. Because of her bravery, Nanye-hi was named Beloved Woman. This gave her special privileges.',
      'Buffalo Calf Road Woman rode her horse into battle to save her brother. Her actions inspired the Cheyenne warriors to keep fighting. She is credited with knocking General Custer off of his horse.',
      'Lozen knew how to hunt, fight, and do tasks that men usually did. She had a special skill for knowing which direction enemies were coming from. She fought against the U.S. and Mexican governments to protect her people.',
      'As a child, Susan La Flesche saw a white doctor refuse to care for her tribe. This made her want to become a doctor. Susan became the first Native American to earn a medical degree and to advocate for her people.',
    ],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.FREEZE_OUT,
    displayName: 'Freeze-Out',
    release: { [PRODUCT_READING]: [Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.LOCALDEV] },
    categories: [GameCategories.BOOKS],
    chapterNames: ['Chapter1', 'Chapter2', 'Chapter3', 'Chapter4'],
    chapterSummaries: [
      'Dr. Gray and Emma perfected Glaciotone. Emma is excited about the possibilities of the chemical, but Dr. Gray tells her to keep it a secret because Dr. Rex threatened her.',
      'Dr. Gray and Emma discovered that Dr. Rex broke into the lab and stole the Glaciotone. The city’s water supply is frozen and the consequences played out on local news.',
      'Dr. Gray and Emma worked all day to create Liquescotone, a chemical that will neutralize Glaciotone. Dr. Gray rushed to let city leaders know, while Emma guarded the lab.',
      'Emma stops Bruno and Dr. Rex from dumping the Liquescotone down the drain. Dr Gray returns from City Hall with reporters and Dr. Rex is exposed. Bruno joins Dr. Gray and Emma with their work.',
    ],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.GYM_CLASS,
    displayName: 'Gym Class',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.HEDGEHOG_AND_FOX,
    displayName: 'Hedgehog and Fox',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.HUNT_FOR_RAGNARS_SCIMITAR,
    displayName: 'The Hunt for Ragnar\'s Scimitar',
    release: { [PRODUCT_READING]: [Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.LOCALDEV] },
    categories: [GameCategories.BOOKS],
    chapterNames: ['Chapter1', 'Chapter2', 'Chapter3', 'Chapter4'],
    chapterSummaries: [
      'Eric is on the hunt for his Uncle Ragnar\'s special scimitar, which he realizes is missing. With the help of his sister Hilde, he thinks of who may have stolen the scimitar from his uncle.',
      'Eric searches Asger\'s hut for the sword while Hilde keeps lookout, but Asger catches them. Asger suggests that Eric\'s aunt Olga must have taken it.',
      'Eric finds Aunt Olga walking outside and takes her bag from her. When he dumps out the contents, he does not find the sword. Both he and Aunt Olga realize that Asger was lying.',
      'Eric and his family run to the docks to catch Asger before he escapes. Ragnar returns just in time on his ship to capture Asger. Everyone celebrates with a big feast.',
    ],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.JUMP_ROPE,
    displayName: 'Jump Rope',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.LIFTING_UP_THE_SKY,
    displayName: 'Lifting Up the Sky',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    summary: 'A Snohomish legend that explains how the constellations came to be in the sky.',
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.LITTLE_HERCULES,
    displayName: 'The Adventures of Young Hercules',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    summary: 'A tall tale about a modern-day Hercules and the mischief that ensues when he tries to do simple things.',
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.LITTLE_MOUSE_ANIMALS,
    displayName: 'Little Mouse and the Animals',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.NICHOLAS_BROTHERS,
    displayName: 'The Wonderful Nicholas Brothers',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    summary: 'Fayard and Harold Nicholas, two brothers, changed the way we think about tap dancing and influenced generations to come.',
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.ONCE_UPON_A_SWING,
    displayName: 'Once Upon a Swing',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.PEOPLE_OF_RENAISSANCE,
    displayName: 'People of the Renaissance',
    release: { [PRODUCT_READING]: [Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.LOCALDEV] },
    categories: [GameCategories.BOOKS],
    chapterNames: ['Chapter1', 'Chapter2', 'Chapter3', 'Chapter4'],
    chapterSummaries: [
      'The Medici family was one of the wealthiest and most powerful families in Florence. They discovered some of the most important Renaissance artists including, Michelangelo and Leonardo da Vinci.',
      'Leonardo da Vinci was more than just an artist; he was also an inventor. He is a true example of a “Renaissance man” (a person who is good at many different things).',
      'Christine de Pizan was the first European woman to earn a living as a writer, at a time when women had little independence and education. ',
      'The Italian trader, Marco Polo, was the first European to spend an extended amount of time in China. Many people did not believe the stories he brought back to Europe with him. ',
    ],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.POP_IN_TIME,
    displayName: 'A Pop in Time',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.ROBOT_GIRL_MYSTERY,
    displayName: 'The Robot Girl Mystery',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    summary: 'After realizing their favorite mystery author is experiencing a mystery of her own, Mia and Carlos try and help her solve it.',
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.SKIN_WE_ARE_IN,
    displayName: 'The Skin You Are In',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    summary: 'Learn why your skin is one of the most important organs in your body.',
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.SPACEWALKS,
    displayName: 'Space Walks',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    summary: 'Learn more about the important but dangerous act of a space walk, and why it is important for astronauts to do them.',
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.VOLCANOES_EXPLOSIONS,
    displayName: 'Volcanoes: Explosions in the Skies and Seas',
    release: { [PRODUCT_READING]: [Environment.DEV, Environment.SANDBOX, Environment.CI, Environment.LOCALDEV] },
    categories: [GameCategories.BOOKS],
    chapterNames: ['Chapter1', 'Chapter2', 'Chapter3', 'Chapter4'],
    chapterSummaries: [
      'Volcanoes are mountain-like structures that spew lava when they erupt. Lava hardens into rock and helps volcanoes grow.',
      'Underwater volcanoes create islands. Two recent islands are Surtsey and Hunga Tonga-Hunga Ha\'apai.While many volcanic islands are delicate and do not last long, these two islands still exist today.',
      'Volcanic eruptions can be deadly and destructive. The deadliest eruption in recent history killed more than 20,000 people. Eruptions can trigger mudslides, earthquakes, and tsunamis.',
      'Despite the dangers, many people still live near volcanoes because of the rich soil. Cooled lava is a major resource for minerals and the heat from volcanoes can be used for energy.',
    ],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.WARTHOG_KNEES,
    displayName: 'Why Warthog Goes About on His Knees',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.WHERE_AM_I,
    displayName: 'Where Am I?',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.WHERE_IS_MR_NIBBLES,
    displayName: 'Where is Mr. Nibbles?',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
];

const spanishBookList = [
  {
    canonicalName: BookIds.AVENTURA_BARRIO,
    displayName: 'Una aventura por el barrio',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.BERNARDO_HERO,
    displayName: 'Bernardo de Gálvez',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.CAMBIA_PLANTA,
    displayName: '¿Cómo cambia una planta?',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.CAPIBARA_ANIMAL,
    displayName: 'La capibara, un animal amigable',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.CROAN_RANAS,
    displayName: '¿Por qué croan las ranas?',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.DESEOS_SOL,
    displayName: 'Deseos al sol',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.DIA_INDEPENDENCIA,
    displayName: 'El Día de la Independencia',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.DIFERENTES_IGUALES,
    displayName: 'Diferentes… pero iguales',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.DOLORES_HUERTA,
    displayName: 'Dolores Huerta',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.DONDE_TINA,
    displayName: '¿Qué pasa con Tina la gallina?',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.EFFECTO_MARIPOSA,
    displayName: 'El efecto mariposa',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.MARIA_EXPLORADORA,
    displayName: 'María la exploradora',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.ESTACIONES_TIEMPO,
    displayName: 'Las estaciones del año',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.FASCINANTES_RUTAS,
    displayName: 'La fascinante Ruta de la Seda',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.FESTIN_SABORES,
    displayName: 'Un festín de sabores',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.HORMIGAS_AMIGAS,
    displayName: 'Hormigas amigas',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.LAS_MARIPOSAS,
    displayName: 'Las mariposas',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.LA_DESPEDIDA,
    displayName: 'La despedida',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.LEYENDA_COLIBRI,
    displayName: 'La leyenda del colibrí',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.LOS_ALUXES,
    displayName: 'Los aluxes',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.POP_TIEMPO,
    displayName: 'Un ¡pop! a tiempo',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.PUEDES_HACER,
    displayName: '¿Qué puedes hacer con los sentidos?',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.QUETZAL_DORADO,
    displayName: 'El quetzal dorado',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.RUIDOSO_CUERPO,
    displayName: 'Mi ruidoso cuerpo',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.SEMILLA_FLOR,
    displayName: 'De la semilla a la flor',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.VERDADERA_FORTUNA,
    displayName: 'La verdadera fortuna',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
  {
    canonicalName: BookIds.ZORRO_HUAYCHAO,
    displayName: 'El zorro y el huaychao',
    categories: [GameCategories.BOOKS],
    chapterNames: [],
    chapterSummaries: [],
    fieldTrialOnly: false,
  },
];

// make a new array that adds default values to BookList objects
const bookListWithDefaults = [
  ...BookList.map(bookDetails => ({
    ...bookListDefaults,
    ...bookDetails,
    categories: [...bookDetails.categories, GameCategories.ALL_GAMES],
    release: { ...bookListDefaults.release, ...bookDetails.release },
  })),
  ...spanishBookList.map(bookDetails => ({
    ...spanishBookListDefaults,
    ...bookDetails,
    categories: [...bookDetails.categories, GameCategories.ALL_GAMES],
    release: { ...spanishBookListDefaults.release, ...bookDetails.release },
  })),
];

export default bookListWithDefaults;
